// src/components/TemplateList.js
import React, { useEffect, useState } from 'react';
import { List, ListItem, ListItemText, IconButton, ListItemSecondaryAction, Collapse, Typography, Box } from '@mui/material';
import { Edit, Delete, ExpandLess, ExpandMore } from '@mui/icons-material';
import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import DeleteConfirmationDialog from './atoms/DeleteConfirmationDialog';

const TemplateList = ({ onEdit }) => {
  const [templates, setTemplates] = useState([]);
  const [open, setOpen] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      const user = auth.currentUser;

      if (user) {
        const q = query(collection(db, 'templates'), where('userId', '==', user.uid));
        const querySnapshot = await getDocs(q);
        setTemplates(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      }
    };

    fetchTemplates();
  }, []);

  const handleToggle = (id) => {
    setOpen(prevOpen => ({ ...prevOpen, [id]: !prevOpen[id] }));
  };

  const handleDelete = async () => {
    if (templateToDelete) {
      await deleteDoc(doc(db, 'templates', templateToDelete));
      setTemplates(templates.filter(template => template.id !== templateToDelete));
      setDeleteDialogOpen(false);
      setTemplateToDelete(null);
    }
  };

  const confirmDelete = (id) => {
    setTemplateToDelete(id);
    setDeleteDialogOpen(true);
  };

  return (
    <>
      <List>
        {templates.map((template) => (
          <div key={template.id}>
            <ListItem 
              button 
              onClick={() => handleToggle(template.id)}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.08)',
                  cursor: 'pointer',
                },
              }}
            >
              <ListItemText primary={template.templateName} />
              <Box mr={2}>
                <IconButton edge="end" onClick={() => handleToggle(template.id)}>
                  {open[template.id] ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="edit" onClick={() => onEdit(template)}>
                  <Edit />
                </IconButton>
                <IconButton edge="end" aria-label="delete" onClick={() => confirmDelete(template.id)}>
                  <Delete />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Collapse in={open[template.id]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem>
                  <ListItemText
                    secondary={
                      <div>
                        <Typography variant="body2"><strong>Campaign Source:</strong> {template.campaignSource}</Typography>
                        <Typography variant="body2"><strong>Campaign Medium:</strong> {template.campaignMedium}</Typography>
                        <Typography variant="body2"><strong>Campaign Name:</strong> {template.campaignName}</Typography>
                        {template.campaignId && <Typography variant="body2"><strong>Campaign ID:</strong> {template.campaignId}</Typography>}
                        {template.campaignTerm && <Typography variant="body2"><strong>Campaign Term:</strong> {template.campaignTerm}</Typography>}
                        {template.campaignContent && <Typography variant="body2"><strong>Campaign Content:</strong> {template.campaignContent}</Typography>}
                      </div>
                    }
                  />
                </ListItem>
              </List>
            </Collapse>
          </div>
        ))}
      </List>
      <DeleteConfirmationDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default TemplateList;
